import posthog from "posthog-js";

const key = process.env.REACT_APP_PUBLIC_POSTHOG_KEY;
const host = process.env.REACT_APP_PUBLIC_POSTHOG_HOST || "https://us.i.posthog.com";

let initialized = false;

// Initializes PostHog web analytics with autocapture. No-ops silently until a
// valid project key is supplied via REACT_APP_PUBLIC_POSTHOG_KEY.
export function initPostHog() {
  if (initialized || typeof window === "undefined") return;
  if (!key || !key.startsWith("phc_")) return;
  posthog.init(key, {
    api_host: host,
    autocapture: true,
    capture_pageview: "history_change",
    capture_pageleave: true,
    defaults: "2026-08-30",
  });
  initialized = true;
}

export function track(event, props = {}) {
  if (!initialized) return;
  try { posthog.capture(event, props); } catch { /* no-op */ }
}

export default posthog;
